import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
import { useUploadProgress } from '@/common/hooks/useUploadProgress';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    inline: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const {
      isUploading,
      isUploadComplete,
      displayUploadProgress,
      uploadStatusText
    } = useUploadProgress();
    return (_ctx, _cache) => {
      const _component_el_progress = _resolveComponent("el-progress");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body",
        disabled: _ctx.inline
      }, [_unref(isUploading) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['upload-progress-tip', _ctx.inline ? 'is-inline' : 'is-global'])
      }, [_createVNode(_component_el_progress, {
        percentage: _unref(displayUploadProgress),
        "stroke-width": 10,
        status: _unref(isUploadComplete) ? 'success' : undefined
      }, null, 8, ["percentage", "status"]), _createElementVNode("p", {
        class: _normalizeClass(["upload-progress-text", {
          'is-success': _unref(isUploadComplete)
        }])
      }, _toDisplayString(_unref(uploadStatusText)), 3)], 2)) : _createCommentVNode("", true)], 8, ["disabled"]);
    };
  }
});